<template>
  <div class="recommend" v-if="list.length">
    <div class="recommend_title">更多推荐</div>
    <div class="recommend_list">
      <div class="recommend_item" v-for="(card, index) in list" :key="index">
        <card1 :item="card" @pauseMedia="pauseMedia" v-if="cardType(card) === 'card1'"></card1>
        <card2 :item="card" @pauseMedia="pauseMedia" v-if="cardType(card) === 'card2'"></card2>
        <card3 :item="card" @pauseMedia="pauseMedia" v-if="cardType(card) === 'card3'"></card3>
        <card4 :item="card" @pauseMedia="pauseMedia" v-if="cardType(card) === 'card4'"></card4>
        <card5 :item="card" @pauseMedia="pauseMedia" v-if="cardType(card) === 'card5'"></card5>
        <card6 :item="card" @pauseMedia="pauseMedia" v-if="cardType(card) === 'card6'"></card6>
      </div>
    </div>
  </div>
</template>

<script>
import card1 from './card1'
import card2 from './card2'
import card3 from './card3'
import card4 from './card4'
import card5 from './card5'
import card6 from './card6'

export default {
  name: 'recommend',
  data () {
    return {
      list: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 初始化
    init () {
      this.getList()
    },
    // 获取稿件列表
    getList () {
      this.$http.get( `recommend/article/${ this.$route.params.id }` ).then( result => {
        if ( result.code === 1000 ) {
          this.list = result.data
        }
      } )
    },
    cardType ( item ) {
      // console.log( item )
      // item.type = 1
      // item.showType = 4
      let content = 'card5'
      // 1. 图文稿件，6种样式都可展示
      // 2. 视频、直播，大图模式
      // 3. 音频，左文右图，大图
      // 4. 数藏，6种
      if ( item.type === 1 ) {
        if ( item.showType === 1 ) {
          content = 'card1'
        } else if ( item.showType === 2 || item.showType === 7 ) {
          content = 'card2'
        } else if ( item.showType === 3 ) {
          content = 'card3'
        } else if ( item.showType === 4 ) {
          content = 'card4'
        } else if ( item.showType === 5 ) {
          content = 'card5'
        } else if ( item.showType === 6 || item.showType === 9 ) {
          content = 'card6'
        }
      } else if ( item.type === 2 ) {
        if ( item.showType === 2 ) {
          content = 'card2'
        } else {
          content = 'card1'
        }
      } else if ( [ 83, 84, 89 ].includes( item.type ) ) {
        content = 'card2'
      } else if ( item.type === 25 ) {
        if ( item.showType === 2 ) {
          content = 'card2'
        } else {
          content = 'card1'
        }
      }
      return content
    },
    // 暂停音视频
    pauseMedia () {
      try {
        let videos = document.getElementsByTagName( 'video' )
        if ( videos ) {
          for ( let i = 0; i < videos.length; i++ ) {
            videos[ i ].pause()
          }
        }
        let audios = document.getElementsByTagName( 'audio' )
        if ( audios ) {
          for ( let i = 0; i < audios.length; i++ ) {
            audios[ i ].pause()
          }
        }
      } catch ( err ) {
        console.log( err )
      }
    }
  },
  components: {
    card1,
    card2,
    card3,
    card4,
    card5,
    card6,
  }
}
</script>

<style scoped>
.recommend_title {
  box-sizing: border-box;
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}
</style>